const GET_MERCHANT_INFO_REQUEST = 'GET_MERCHANT_INFO_REQUEST';
const GET_MERCHANT_INFO_SUCCESS = 'GET_MERCHANT_INFO_SUCCESS';
const GET_MERCHANT_INFO_ERROR = 'GET_MERCHANT_INFO_ERROR';
const FETCH_PG_CONFIG_EDIT_REQUEST = 'FETCH_PG_CONFIG_EDIT_REQUEST';
const FETCH_PG_CONFIG_EDIT_SUCCESS = 'FETCH_PG_CONFIG_EDIT_SUCCESS';
const FETCH_PG_CONFIG_EDIT_ERROR = 'FETCH_PG_CONFIG_EDIT_ERROR';
const FETCH_ROUTER_DETAILS_REQUEST = 'FETCH_ROUTER_DETAILS_REQUEST';
const FETCH_ROUTER_DETAILS_SUCCESS = 'FETCH_ROUTER_DETAILS_SUCCESS';
const FETCH_ROUTER_DETAILS_ERROR = 'FETCH_ROUTER_DETAILS_ERROR';
const FETCH_SURCHARGE_DETAILS_REQUEST = 'FETCH_SURCHARGE_DETAILS_REQUEST';
const FETCH_SURCHARGE_DETAILS_SUCCESS = 'FETCH_SURCHARGE_DETAILS_SUCCESS';
const FETCH_SURCHARGE_DETAILS_ERROR = 'FETCH_SURCHARGE_DETAILS_ERROR';
const UPDATE_MERCHANT_DATA_REQUEST = 'UPDATE_MERCHANT_DATA_REQUEST';
const UPDATE_MERCHANT_DATA_SUCCESS = 'UPDATE_MERCHANT_DATA_SUCCESS';
const UPDATE_MERCHANT_DATA_ERROR = 'UPDATE_MERCHANT_DATA_ERROR';
const UPDATE_PG_CONFIG_DATA_REQUEST = 'UPDATE_PG_CONFIG_DATA_REQUEST';
const UPDATE_PG_CONFIG_DATA_SUCCESS = 'UPDATE_PG_CONFIG_DATA_SUCCESS';
const UPDATE_PG_CONFIG_DATA_ERROR = 'UPDATE_PG_CONFIG_DATA_ERROR';
const UPDATE_ROUTING_DATA_REQUEST = 'UPDATE_ROUTING_DATA_REQUEST';
const UPDATE_ROUTING_DATA_SUCCESS = 'UPDATE_ROUTING_DATA_SUCCESS';
const UPDATE_ROUTING_DATA_ERROR = 'UPDATE_ROUTING_DATA_ERROR';
const UPDATE_SURCHARGE_DATA_REQUEST = 'UPDATE_SURCHARGE_DATA_REQUEST';
const UPDATE_SURCHARGE_DATA_SUCCESS = 'UPDATE_SURCHARGE_DATA_SUCCESS';
const UPDATE_SURCHARGE_DATA_ERROR = 'UPDATE_SURCHARGE_DATA_ERROR';
const UPDATE_SECTION_DETAILS_REQUEST = 'UPDATE_SECTION_DETAILS_REQUEST';
const UPDATE_SECTION_DETAILS_SUCCESS = 'UPDATE_SECTION_DETAILS_SUCCESS';
const UPDATE_SECTION_DETAILS_ERROR = 'UPDATE_SECTION_DETAILS_ERROR';
const RESET_UPDATE_DATA_SUCCESS_KEY = 'RESET_UPDATE_DATA_SUCCESS_KEY';
const GET_MERCHANT_SECTION_INFO_REQUEST = 'GET_MERCHANT_SECTION_INFO_REQUEST';
const GET_MERCHANT_SECTION_INFO_SUCCESS = 'GET_MERCHANT_SECTION_INFO_SUCCESS';
const GET_MERCHANT_SECTION_INFO_ERROR = 'GET_MERCHANT_SECTION_INFO_ERROR';
const SET_SELECTED_ENTITY_REQUEST = 'SET_SELECTED_ENTITY_REQUEST';
const SET_SELECTED_ENTITY_SUCCESS = 'SET_SELECTED_ENTITY_SUCCESS';
const SET_SELECTED_ENTITY_ERROR = 'SET_SELECTED_ENTITY_ERROR';
const UPDATE_SETTLEMENT_DATA_REQUEST = 'UPDATE_SETTLEMENT_DATA_REQUEST';
const UPDATE_SETTLEMENT_DATA_SUCCESS = 'UPDATE_SETTLEMENT_DATA_SUCCESS';
const UPDATE_SETTLEMENT_DATA_ERROR = 'UPDATE_SETTLEMENT_DATA_ERROR';
const FETCH_BASIC_FORM_DATA = 'FETCH_BASIC_FORM_DATA';
const FETCH_BASIC_FORM_DATA_SUCCESS = 'FETCH_BASIC_FORM_DATA_SUCCESS';
const FETCH_BASIC_FORM_DATA_ERROR = 'FETCH_BASIC_FORM_DATA_ERROR';

const ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST =
    'ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST';
const ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS =
    'ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS';
const ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR =
    'ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR';


export {
    GET_MERCHANT_INFO_REQUEST,
    GET_MERCHANT_INFO_SUCCESS,
    GET_MERCHANT_INFO_ERROR,
    FETCH_PG_CONFIG_EDIT_REQUEST,
    FETCH_PG_CONFIG_EDIT_SUCCESS,
    FETCH_PG_CONFIG_EDIT_ERROR,
    FETCH_ROUTER_DETAILS_REQUEST,
    FETCH_ROUTER_DETAILS_SUCCESS,
    FETCH_ROUTER_DETAILS_ERROR,
    FETCH_SURCHARGE_DETAILS_REQUEST,
    FETCH_SURCHARGE_DETAILS_SUCCESS,
    FETCH_SURCHARGE_DETAILS_ERROR,
    UPDATE_MERCHANT_DATA_REQUEST,
    UPDATE_MERCHANT_DATA_SUCCESS,
    UPDATE_MERCHANT_DATA_ERROR,
    UPDATE_PG_CONFIG_DATA_REQUEST,
    UPDATE_PG_CONFIG_DATA_SUCCESS,
    UPDATE_PG_CONFIG_DATA_ERROR,
    UPDATE_ROUTING_DATA_REQUEST,
    UPDATE_ROUTING_DATA_SUCCESS,
    UPDATE_ROUTING_DATA_ERROR,
    UPDATE_SURCHARGE_DATA_REQUEST,
    UPDATE_SURCHARGE_DATA_SUCCESS,
    UPDATE_SURCHARGE_DATA_ERROR,
    UPDATE_SECTION_DETAILS_REQUEST,
    UPDATE_SECTION_DETAILS_SUCCESS,
    UPDATE_SECTION_DETAILS_ERROR,
    RESET_UPDATE_DATA_SUCCESS_KEY,
    GET_MERCHANT_SECTION_INFO_REQUEST,
    GET_MERCHANT_SECTION_INFO_SUCCESS,
    GET_MERCHANT_SECTION_INFO_ERROR,
    SET_SELECTED_ENTITY_REQUEST,
    SET_SELECTED_ENTITY_SUCCESS,
    SET_SELECTED_ENTITY_ERROR,
    UPDATE_SETTLEMENT_DATA_REQUEST,
    UPDATE_SETTLEMENT_DATA_SUCCESS,
    UPDATE_SETTLEMENT_DATA_ERROR,
    FETCH_BASIC_FORM_DATA,
    FETCH_BASIC_FORM_DATA_SUCCESS,
    FETCH_BASIC_FORM_DATA_ERROR,
    ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
    ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS,
    ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR,
};
